import { Dashboard, User } from '@apis'
import { GridCard, Status, Table, TableActions, TableUser } from '@components'
import { IGridItem } from '@components/gridCard'
import { StyleColumn } from '@components/styles'
import { Actions, store } from '@store/index'
import { searchHandler } from '@utils/search'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
const AdminUserManagement = ({ hasStat = true }) => {
  const navigate = useNavigate()
  const [isFetching, setIsFetching] = useState(false)
  const {
    items: users,
    totalPages,
    loading: fetching,
  } = useSelector((state: any) => state.users)
  const debounceRef: any = useRef(null)
  const { data: dashboard } = useSelector((state: any) => state.usersDashboard)
  const fetchUsers = async (params: any) => {
    await User.list('users', params).catch(() => {})
  }
  const [params, setParams] = useState({ page: 1, limit: 10 })
  const fetchDashboard = async () => {
    const params = {
      type: 'allUser',
    }
    await Dashboard.getAllDashboardCount('usersDashboard', params)
  }

  useEffect(() => {
    {
      hasStat && fetchDashboard()
    }

    if (!users?.length) {
      fetchUsers(params)
    }
  }, [])
  const items: IGridItem[] = [
    {
      title: 'Total Users',
      value: dashboard?.totalUsers || '0',
      Icon: 'userThree',
    },
    {
      title: 'Total Subscribed Users',
      value: dashboard?.totalSubscribedUsers || '0',
      Icon: 'userThree',
      IconBg: 'greenLight',
    },
    {
      title: 'Total UnSubscribed Users',
      value: dashboard?.totalUnSubscribedUsers || '0',
      Icon: 'userThree',
      IconBg: 'redLight',
    },
    {
      title: 'Total Payment',
      value: `Rs. ${dashboard?.totalPayment ?? '0'}`,
      IconBg: 'yellowLight',
      Icon: 'moneyBag',
    },
  ]
  const columns = [
    {
      title: 'Name',
      key: 'name',
      render: (item: any) => (
        <TableUser
          hasAvatar
          avatar={item?.image}
          label={item?.name}
          secondaryLabel={item?.email}
        />
      ),
    },
    {
      title: 'Phone Number',
      key: 'phoneNo',
    },
    {
      title: 'Address',
      key: 'address',
    },
    {
      title: 'Status',
      key: 'status',
      render: (item: any) => <Status status={item?.status} />,
    },
    {
      title: 'Actions',
      key: 'action',
      render: (item: any) => (
        <TableActions
          hasDelete={false}
          hasEdit={false}
          onView={() => {
            navigate(`/admin/user-managements/view/${item?.id}`)
            store.dispatch(Actions.set('singleUser', item))
          }}
        />
      ),
    },
  ]
  const onSearch = searchHandler({
    fetchFunction: fetchUsers,
    paramKey: 'search',
    debounceTime: 600,
    params,
    setParams,
    debounceRef,
  })
  return (
    <Fragment>
      <StyleColumn>
        {hasStat && <GridCard items={items} />}
        <Table
          tableTitle="User List"
          columns={columns}
          data={users}
          onClickRow={(item) => {
            navigate(`/admin/user-managements/view/${item?.id}`)
            store.dispatch(Actions.set('singleUser', item))
          }}
          loading={fetching || isFetching}
          filter={{
            hasSearch: true,
            hasFilter: true,
            onSearch: onSearch,
            placeholder: 'Name, email , phone number',
          }}
          paginationProps={{
            totalPages: totalPages,
            perPage: params.limit,
            activePage: params?.page,
            handleOnClick: async (pageNo) => {
              setIsFetching(true)
              const updateParams = { ...params, page: pageNo }
              fetchUsers(updateParams)
                .then(() => {
                  setParams(updateParams)
                })
                .catch(() => {})
                .finally(() => {
                  setIsFetching(false)
                })
            },
          }}
        />
      </StyleColumn>
    </Fragment>
  )
}

export default AdminUserManagement
